
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/module-sequence-footer/jst/ModuleSequenceFooter';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <span class=\"module-sequence-footer-button--previous\" data-tooltip=\"right\" data-html-tooltip-title=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.previous)),stack1 == null || stack1 === false ? stack1 : stack1.tooltip)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n          <a\n            href=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.previous)),stack1 == null || stack1 === false ? stack1 : stack1.url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"\n            role=\"button\"\n            class=\"Button\"\n            aria-describedby=\"msf";
  if (helper = helpers.instanceNumber) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.instanceNumber); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-previous-desc\"\n            aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("jquery.module_sequence_footer")
  },data:data},helper ? helper.call(depth0, "previous_module_item_a9e57348", "Previous Module Item", options) : helperMissing.call(depth0, "t", "previous_module_item_a9e57348", "Previous Module Item", options)));
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.previous)),stack1 == null || stack1 === false ? stack1 : stack1.externalItem), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n          >\n            <i class=\"icon-mini-arrow-left\"></i>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("jquery.module_sequence_footer")
  },data:data},helper ? helper.call(depth0, "jquery.module_sequence_footer.previous", "Previous", options) : helperMissing.call(depth0, "t", "jquery.module_sequence_footer.previous", "Previous", options)))
    + "\n            <span id=\"msf";
  if (helper = helpers.instanceNumber) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.instanceNumber); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-previous-desc\" class=\"hidden\" hidden>"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.previous)),stack1 == null || stack1 === false ? stack1 : stack1.tooltipText)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n          </a>\n      </span>\n    ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += " - "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("jquery.module_sequence_footer")
  },data:data},helper ? helper.call(depth0, "opens_in_new_window_b4b99243", "opens in new window", options) : helperMissing.call(depth0, "t", "opens_in_new_window_b4b99243", "opens in new window", options)));
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <span class=\"module-sequence-footer-button--next\" data-tooltip=\"left\" data-html-tooltip-title=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.next)),stack1 == null || stack1 === false ? stack1 : stack1.tooltip)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n        <a\n          href=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.next)),stack1 == null || stack1 === false ? stack1 : stack1.url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"\n          role=\"button\"\n          class=\"Button\"\n          aria-describedby=\"msf";
  if (helper = helpers.instanceNumber) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.instanceNumber); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-next-desc\"\n          aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("jquery.module_sequence_footer")
  },data:data},helper ? helper.call(depth0, "next_module_item_19e835f3", "Next Module Item", options) : helperMissing.call(depth0, "t", "next_module_item_19e835f3", "Next Module Item", options)));
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.next)),stack1 == null || stack1 === false ? stack1 : stack1.externalItem), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n            ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.next)),stack1 == null || stack1 === false ? stack1 : stack1.modules_tab_disabled), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          "
    + escapeExpression((helper = helpers.disabledIf || (depth0 && depth0.disabledIf),options={hash:{},data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.next)),stack1 == null || stack1 === false ? stack1 : stack1.modules_tab_disabled), options) : helperMissing.call(depth0, "disabledIf", ((stack1 = (depth0 && depth0.next)),stack1 == null || stack1 === false ? stack1 : stack1.modules_tab_disabled), options)))
    + "\n        >\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("jquery.module_sequence_footer")
  },data:data},helper ? helper.call(depth0, "jquery.module_sequence_footer.next", "Next", options) : helperMissing.call(depth0, "t", "jquery.module_sequence_footer.next", "Next", options)))
    + "<i class=\"icon-mini-arrow-right\"></i>\n          <span id=\"msf";
  if (helper = helpers.instanceNumber) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.instanceNumber); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-next-desc\" class=\"hidden\" hidden>"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.next)),stack1 == null || stack1 === false ? stack1 : stack1.tooltipText)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n        </a>\n      </span>\n    ";
  return buffer;
  }
function program5(depth0,data) {
  
  
  return " aria-disabled=\"true\" ";
  }

  buffer += "<div class='module-sequence-padding'></div>\n<div class='module-sequence-footer' role=\"navigation\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("jquery.module_sequence_footer")
  },data:data},helper ? helper.call(depth0, "module_navigation_97043417", "Module Navigation", options) : helperMissing.call(depth0, "t", "module_navigation_97043417", "Module Navigation", options)))
    + "\">\n  <div class=\"module-sequence-footer-content\">\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.previous)),stack1 == null || stack1 === false ? stack1 : stack1.show), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.next)),stack1 == null || stack1 === false ? stack1 : stack1.show), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  